function populateSiblingProducts() {
  const form = document.querySelector('.product-purchase-form')
  if (!form) {
    return
  }

  const productId = form.dataset.productId
  if (!productId?.length) {
    return
  }

  let currentProductHandle = null
  let styleCode = null
  try {
    const product = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML)
    currentProductHandle = product?.handle
    styleCode = product?.tags?.find(tag => tag?.startsWith('style:'))?.split(':')?.[1]
    console.log("styleCode", styleCode);
    if (!styleCode?.length) {
      return
    }
  } catch (e) {
    return
  }

  const query = `
    {
      products(first: 250, query:"tag:'style:${styleCode}'") {
        edges {
          node {
            handle
            featuredImage {
              url(transform: { maxWidth: 300 })
            }
            tags
          }
        }
      }
    }
  `

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '9c445d937bc8968e99e6c343c7de362b',
    },
    body: JSON.stringify({ query }),
  }

  fetch('https://portier-australia-pty-ltd.myshopify.com/api/2023-07/graphql', options)
    .then((response) => response.json())
    .then((data) => {
      const products = data?.data?.products?.edges?.map(edge => ({
        handle: edge?.node?.handle,
        image: edge?.node?.featuredImage?.url,
        color: edge?.node?.tags?.find(tag => tag?.startsWith('colour:'))?.split(':')?.[1],
      }))?.sort((a, b) => {
        if (a?.handle === currentProductHandle && b?.handle !== currentProductHandle) return -1
        if (b?.handle === currentProductHandle && a?.handle !== currentProductHandle) return 1
        return 0
      })

      console.log('products', products);

      if (!products?.length) {
        return
      }

      const siblingPickerDiv = document.querySelector('.sibling-picker')
      if (!siblingPickerDiv) {
        return
      }

      const colorDiv = document.createElement('div')
      colorDiv.className = 'sibling-color-wrapper'
      colorDiv.innerHTML = `<span class="sibling-color-title">Colour</span>: ${products?.[0]?.color}`

      const gridDiv = document.createElement('div')
      gridDiv.className = 'sibling-grid'

      products?.forEach(p => {
        const siblingDiv = document.createElement('a')
        siblingDiv.className = 'sibling'
        siblingDiv.href = `/products/${p?.handle}`

        const imageDiv = document.createElement('img')
        imageDiv.src = p?.image
        siblingDiv.appendChild(imageDiv)

        gridDiv.appendChild(siblingDiv)
      })

      siblingPickerDiv.appendChild(colorDiv)
      siblingPickerDiv.appendChild(gridDiv)
    })
    .catch((error) => {});
}

(function ($) {
  populateSiblingProducts()
})(theme.jQuery);

/**
 * Bottom-fixed add-to-cart bar for the product page.
 * The bar is a remote control for the main product form: its selects drive
 * the main option selectors and its button submits the main purchase form,
 * so theme.OptionManager stays the single source of truth. The select
 * mirror runs on variantChanged (the buy-with upsell forms inside the same
 * container bubble that event too, hence the evt.target check); the button
 * mirror runs off a MutationObserver on the purchase form, which also covers
 * the ajax lockout states and apps hiding or replacing the button.
 */
if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('.shopify-section') || document
      this.productForm = scope.querySelector('.product-form[data-product-id="' + this.dataset.productId + '"]')
      this.purchaseForm = this.productForm?.querySelector('form.product-purchase-form[data-product-id="' + this.dataset.productId + '"]')
      this.submitButton = this.querySelector('.sticky-atc__submit')
      this.submitText = this.querySelector('.sticky-atc__submit-text')
      this.footer = document.getElementById('pagefooter')
      this.mobileQuery = window.matchMedia('(max-width: 767.98px)')

      if (!this.productForm || !this.purchaseForm || !this.mainButton()) {
        return
      }

      this.onScroll = () => this.evaluate()
      window.addEventListener('scroll', this.onScroll, { passive: true })

      this.onResize = () => {
        if (this.classList.contains('sticky-atc--visible')) {
          this.setOffsetVar()
        }
        this.evaluate()
      }
      theme.jQuery(window).on('debouncedresize.stickyAtc', this.onResize)

      if (!this.optionListenersBound) {
        this.querySelectorAll('.sticky-atc__option').forEach((select) => {
          select.addEventListener('change', () => this.applyOption(select))
        })
        this.optionListenersBound = true
      }

      this.onVariantChanged = (evt, variant) => {
        if (evt.target !== this.productForm) {
          return
        }
        this.syncFromMain(variant)
        this.evaluate()
      }
      theme.jQuery(this.productForm).on('variantChanged.stickyAtc', this.onVariantChanged)

      this.formObserver = new MutationObserver(() => {
        this.syncButton()
        this.evaluate()
      })
      this.formObserver.observe(this.purchaseForm, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'disabled']
      })

      this.syncFromMain(false)
      this.evaluate()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll)
      theme.jQuery(window).off('debouncedresize.stickyAtc', this.onResize)
      this.formObserver?.disconnect()
      if (this.productForm) {
        theme.jQuery(this.productForm).off('variantChanged.stickyAtc', this.onVariantChanged)
      }
      document.body.classList.remove('sticky-atc-visible')
    }

    mainButton() {
      return this.purchaseForm ? this.purchaseForm.querySelector('button[type="submit"]') : null
    }

    setOffsetVar() {
      document.documentElement.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px')
    }

    evaluate() {
      const main = this.mainButton()
      const formRect = this.purchaseForm.getBoundingClientRect()
      const formOutOfView = this.mobileQuery.matches
        ? formRect.bottom < 0 || formRect.top > window.innerHeight
        : formRect.bottom < 0
      const footerEndReached = this.footer ? this.footer.getBoundingClientRect().bottom <= window.innerHeight + 2 : false
      const ctaHidden = !main || main.offsetParent === null
      const visible = formOutOfView && !footerEndReached && !ctaHidden
      if (visible && !this.classList.contains('sticky-atc--visible')) {
        this.setOffsetVar()
      }
      this.classList.toggle('sticky-atc--visible', visible)
      document.body.classList.toggle('sticky-atc-visible', visible)
    }

    applyOption(select) {
      const selector = this.productForm.querySelector('.option-selector[data-option-index="' + select.dataset.optionIndex + '"]')
      if (!selector || !select.value.length) {
        return
      }
      if (selector.dataset.selectorType === 'dropdown') {
        selector.querySelector('.cc-select')?.dispatchEvent(new CustomEvent('selectOption', { detail: { value: select.value } }))
      } else {
        const input = selector.querySelector('input.js-option[value="' + CSS.escape(select.value) + '"]')
        if (input && !input.checked) {
          input.checked = true
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    }

    syncFromMain(variant) {
      if (variant) {
        this.querySelectorAll('.sticky-atc__option').forEach((select) => {
          const value = variant.options[Number(select.dataset.optionIndex)]
          if (Array.prototype.some.call(select.options, (option) => option.value === value)) {
            select.value = value
          }
        })
      }
      this.syncButton()
    }

    syncButton() {
      const main = this.mainButton()
      if (!main) {
        return
      }
      this.submitText.innerHTML = main.innerHTML
      this.submitButton.classList.toggle('button--sold-out', main.classList.contains('button--sold-out'))
      this.submitButton.disabled = main.disabled
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart)
}
